import React from 'react'
import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import LinearProgress from '@material-ui/core/LinearProgress';
import { DynamicTicketTextItem } from './dynamictickettextitem'
import { isFalsyOrEmpty } from '../helpers/object';

export const TicketWaiting = ({ticket, cancelTicketCallback, peopleaheadtext, ticketnumbertext, leavequeuetext, formdata, dynamicheading, showticketnumber, showpeopleahead, showFormsData, dynamicfooter}) => {
    const theme = useTheme();
    const classes = useStyles(theme);

    const TopText = () => {
      if (isFalsyOrEmpty(dynamicheading))
        return <span/>
      else 
        return (
          <Typography
            align="center"
            variant="h3"
            className={"ticket-toptext"}
            id={"ticket-waiting-toptext"}
          >
            { dynamicheading }
          </Typography>
        )
    }

    const BottomText = () => {
      if (isFalsyOrEmpty(dynamicfooter))
        return <span/>
      else
        return (
          <Typography
            align="center"
            variant="h3"
            className={"ticket-bottomtext"}
            id={"ticket-waiting-bottomtext"}
          >
            { dynamicfooter }
          </Typography>
        )
    }

    const handleCancelTicket = () => {
      cancelTicketCallback(ticket.id);
    }

  return (
    <Box className={classes.wrapper} >
      <Box className={classes.container}>
      { TopText() }
      { 
        showpeopleahead ?
        <Paper elevation={0} className={[classes.semicontainer, "ticket-semicontainers"].join(' ')} id="ticket-waiting-semicontainer-1">
          <Typography
            align="center"
            variant="h6"
            className={[classes.title, "ticket-titles"].join(' ')}
            id="ticket-peopleahead-text-id"
          >
            { peopleaheadtext || "Kunder före dig"}
          </Typography>
          <Typography
            align="center"
            variant="h1"
            className={[classes.valuetext, "ticket-valuetexts"].join(' ')}
            id="ticket-peopleahead-valuetext-id"
          >
            { ticket.peopleAhead >= 0 ? ticket.peopleAhead : "-" }
          </Typography>
        </Paper>
        :
        <span/>
      }
      {
        showticketnumber ? 
        <Paper elevation={0} className={[classes.semicontainer, "ticket-semicontainers"].join(' ')} id="ticket-waiting-semicontainer-2">
          <Typography
            align="center"
            variant="h6"
            className={[classes.title, "ticket-titles"].join(' ')}
            id="ticket-ticketnumber-text-id"
          >
            { ticketnumbertext || "Ditt turnummer" }
          </Typography>
          <Typography
            align="center"
            variant="h1"
            className={[classes.valuetext, "ticket-valuetexts"].join(' ')}
            id="ticket-ticketnumber-valuetext-id"
          >
            { ticket.ticketnumber}
          </Typography>
        </Paper>
        :
        <span/>
      }
      <Typography
            align="center"
            variant="label"
            className={[classes.timestamptext, "ticket-timestamp-texts"].join(' ')}
            id="ticket-waiting-timestamp-text-id"
          >
            { ticket.timestamp }
      </Typography>
      {
        showFormsData && formdata ?
        <Paper elevation={0} className={[classes.semicontainer, "ticket-semicontainers"].join(' ')} id="ticket-waiting-semicontainer-3">
          { formdata ? formdata.map(x => { return <DynamicTicketTextItem label={x.id} text={x.value} />}) : <span/> }
        </Paper>
        :
        <span/>
      }
      { BottomText() }
      </Box>
      <div className={classes.buttonwrapper} id="ticket-leavequeue-button-wrapper-id">
        <Button variant="contained" className={[classes.button, "buttons", "secondary-buttons"].join(' ')} onClick={handleCancelTicket} elevation={0} id="ticket-leavequeue-button-id">
          { <Typography className="secondary-buttons-texts" id="ticket-leavequeue-button-text">{leavequeuetext || ""}</Typography>}
        </Button>
      </div>
      <LinearProgress className={[classes.spinner, "progress-bar"].join(' ')} classes={{barColorPrimary: classes.barColorPrimary, colorPrimary: classes.colorPrimary}} />
    </Box>
  )
}

const useStyles = makeStyles({
  container: theme => ({
    backgroundColor: theme.palette.background.main,
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    position: 'relative',
    alignItems: 'center',
    overflow: 'auto'
  }),
  wrapper: {
    display: 'flex', 
    flexDirection: 'column', 
    height: '100%',
    overflow: 'auto'
  },
  semicontainer: theme => ({
    minWidth: '300px',
    maxWidth: '80%',
    borderRadius: '20px',
    backgroundColor: theme.palette.ticket_waiting.main,
    margin: '0.5rem 0 0.25rem 0',
    padding: '0 0.5rem 0.5rem 0.5rem'
  }),
  title: theme => ({
    color: theme.palette.secondary_text.main,
    marginTop: '0.5rem'
  }),
  valuetext: theme => ({
    color: theme.palette.button_text.main,
    fontSize: '4rem',
    fontWeight: '900',
    [theme.breakpoints.down('xs')]: {
     fontSize: '3rem' 
    }
  }),
  timestamptext: theme => ({
    color: theme.palette.secondary_text.main,
    fontSize: 'small'
  }),
  button: theme => ({
    backgroundColor: theme.palette.info.main,
    color: theme.palette.secondary.main,
    borderRadius: 0,
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.button_text.main
      }
    }
  }),
  buttonwrapper: {
    marginTop: 'auto',
    marginBottom: '0.5rem'
  },
  barColorPrimary: theme => ({
    backgroundColor: theme.palette.loadingbar_front.main
  }),
  colorPrimary: theme => ({
    backgroundColor: theme.palette.loadingbar_back.main
  }),
  spinner: {
    width: '100%',
    height: '0.5rem'
  },
})